module.exports = __webpack_public_path__ + "img/icon-truck.23949f45.svg";